export const bnklink = "https://d3hhrps04devi8.cloudfront.net/bnk48profile/";
export const bnktype = ".jpg";
export const cgmlink = "https://d3hhrps04devi8.cloudfront.net/cgm48profile/";
export const cgmtype = ".jpg";